export default __webpack_public_path__ + "static/media/Kidneys.b16ae1d0.svg";